import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssociationsRoutingModule } from './associations-routing.module';
import { AssociationsComponent } from './associations.component';
import { AddnewComponent } from './addnew/addnew.component';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MaterialModule } from '../material.module';
import {MatPaginatorModule} from '@angular/material/paginator';
import { ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    AssociationsComponent,
    AddnewComponent,
    
  ],
  imports: [
    CommonModule,
    AssociationsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    MaterialModule,
    MatPaginatorModule,
    MatProgressSpinnerModule
  ],
  exports:[
    AssociationsComponent,AddnewComponent
  ]
})
export class AssociationsModule { }
